import { GET_AUDIT_DETAILS_REQUEST, GET_AUDIT_DETAILS_SUCCESS, GET_AUDIT_DETAILS_FAILED, GET_AUDIT_DETAILS_RESET } from "../types"

/****************Ragnar Lodbrok****************/
//get audit details

export const getAuditDetails = (data) => ({
	type: GET_AUDIT_DETAILS_REQUEST,
	payload: data,
})

export const getAuditDetailsSuccess = (data) => ({
	type: GET_AUDIT_DETAILS_SUCCESS,
	payload: data,
})

export const getAuditDetailsFailed = (data) => ({
	type: GET_AUDIT_DETAILS_FAILED,
	payload: data,
})

export const getAuditDetailsReset = () => ({
	type: GET_AUDIT_DETAILS_RESET,
})
